export default "__VITE_ASSET__DLdyT14Q__"